import { organizationSliceActions } from "..";

export const getOrgInfo = ({idsrv, type}) => (dispatch) => {

  const url = new URL(
    "https://menu.unotec.kz/api/orgparams"
  )

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
    body: JSON.stringify({
      idsrv
    }),
  };
  
  dispatch(organizationSliceActions.startLoading())

  fetch(url, options)
  .then((response) => response.json())
  .then((data) => {
    if (data[0]['WORK_TYPE'] === 2 && type === undefined){
      data[0]['WORK_TYPE'] = 0;
    }
    dispatch(organizationSliceActions.successLoading(data[0]));
  })
  .catch((err) => {
    console.log(err);
    dispatch(organizationSliceActions.failLoading());
  });
};